import React from 'react';

export const tableCols = [
  {
    headerName: 'ID',
    field: 'dbId',
    width: 50,
  },
  {
    headerName: 'Name',
    field: 'name',
    flex: 1,
//    filter: true,
  },
  {
    headerName: 'Description',
    field: 'description',
    flex: 1,
//    filter: true,
  },
/*  {
    headerName: 'Tags',
    field: 'tags',
    flex: 1,
    valueGetter: ({ value }) => value
      ?.map(({ tag }) => tag)
      ?.join(', '),
    tooltipValueGetter: ({ data }) => data?.tags
      ?.map(({ tag }, index) => (
        <p key={`${tag}-${index}`}>{tag}</p>
      ))
  },*/
];
